let payload = null
let pasteUsed = false
const listeners = new Set()
const pasteListeners = new Set()
const activeListeners = new Set()
// active state: { copy: <object|null>, pastes: Set<id> }
let activeState = { copy: null, pastes: new Set() }

export function setCopyPayload(p) {
  payload = p
  // selecting a new copy re-enables paste usage
  pasteUsed = false
  listeners.forEach((l) => {
    try { l(payload) } catch (e) {}
  })
  pasteListeners.forEach((l) => {
    try { l(pasteUsed) } catch (e) {}
  })
  try { document.dispatchEvent(new CustomEvent('ecosystem:copyPayload', { detail: payload })) } catch (e) {}
}

export function getCopyPayload() {
  return payload
}

export function setActiveDetail(d) {
  // d is expected to be an object for copy (e.g. { id, button: 'copy', ... }) or null
  activeState.copy = d
  // when a copy is set, clear any active pastes
  if (d) {
    try {
      activeState.pastes.clear()
    } catch (e) {}
  }
  activeListeners.forEach((l) => {
    try { l(getActiveDetail()) } catch (e) {}
  })
}

export function getActiveDetail() {
  // return a shallow copy to avoid external mutation
  return { copy: activeState.copy, pastes: Array.from(activeState.pastes) }
}

export function subscribeActive(fn) {
  activeListeners.add(fn)
  // immediately call with current state
  try { fn(getActiveDetail()) } catch (e) {}
  return () => activeListeners.delete(fn)
}

export function addActivePaste(d) {
  // d should include an identifier in `id` (species or header id)
  if (!d || !('id' in d)) return
  try { activeState.pastes.add(d.id) } catch (e) {}
  activeListeners.forEach((l) => {
    try { l(getActiveDetail()) } catch (e) {}
  })
}

export function clearActivePastes() {
  try { activeState.pastes.clear() } catch (e) {}
  activeListeners.forEach((l) => {
    try { l(getActiveDetail()) } catch (e) {}
  })
}

export function setPasteUsed(v) {
  pasteUsed = Boolean(v)
  pasteListeners.forEach((l) => {
    try { l(pasteUsed) } catch (e) {}
  })
  try { document.dispatchEvent(new CustomEvent('ecosystem:pasteUsed', { detail: pasteUsed })) } catch (e) {}
}

export function getPasteUsed() {
  return pasteUsed
}

export function resetStore() {
  payload = null
  pasteUsed = false
  try { activeState.copy = null } catch (e) {}
  try { activeState.pastes.clear() } catch (e) {}
  // notify subscribers
  listeners.forEach((l) => {
    try { l(payload) } catch (e) {}
  })
  pasteListeners.forEach((l) => {
    try { l(pasteUsed) } catch (e) {}
  })
  activeListeners.forEach((l) => {
    try { l(getActiveDetail()) } catch (e) {}
  })
  try { document.dispatchEvent(new CustomEvent('ecosystem:copyCleared', { detail: { time: Date.now() } })) } catch (e) {}
}

export function subscribe(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function subscribePasteUsed(fn) {
  pasteListeners.add(fn)
  return () => pasteListeners.delete(fn)
}
